/**
 * Wann die Leinwand beim Abspielen wirklich neu gezeichnet werden muss.
 *
 * Der Abspielkopf wandert sechzigmal in der Sekunde. Bisher hing die Vorschau
 * daran und lief jedes Mal durch: gemessen 154 Durchläufe in 1,2 Sekunden, der
 * ganze Baum, bei jedem Bild. Auf einem Rechner ist das ein Prozent der
 * Bildzeit; auf dem Telefon ist es die Zeit, die dem Dekoder fehlt (Sascha,
 * 8. September: „leider ruckelt alles auf iOS immer noch sehr stark“).
 *
 * Dabei ändert sich das Bild meistens gar nicht. Ein Video ohne Keyframes,
 * ohne Blende, ohne Anflug sieht bei 3,10 s aus wie bei 3,09 s — das Bild malt
 * der Dekoder, nicht React. Also wird nicht mehr der Kopf weitergereicht,
 * sondern das, was aus ihm folgt. Hier stehen die drei Entscheidungen, die
 * dabei nötig sind; sie stehen hier und nicht in der Vorschau, weil man sie
 * dann prüfen kann.
 */
/**
 * In welchem Takt die Medienzeit in den Schlüssel eingeht: 200 ms.
 *
 * Der Boden unter allem. Er hält den Abgleich der Elemente am Leben (Tempo,
 * Lautstärke, Nachziehen eines Elements, das auseinandergelaufen ist) — fünfmal
 * in der Sekunde statt sechzigmal. Ganz abschalten wäre falsch: dann käme ein
 * Element, das hängt, nie zurück.
 */
export const TAKT = 0.2;
/** Die Medienzeit als Stufe. Gleiche Stufe heisst: kein Abgleich nötig. */
export function taktStufe(mediaTime) {
    return Math.round(mediaTime / TAKT);
}
/**
 * Die Lautstärke in Schritten von fünf Prozent.
 *
 * Feiner bräuchte es einen Durchlauf je Bild, nur weil eine Pegelkurve steigt —
 * und eine Pegelkurve ist nichts, was man sieht. Eine Absenkung unter Sprache
 * fährt damit in rund vierzehn Stufen herunter statt in sechzig; das hört
 * niemand, und es kostet die Leinwand nichts.
 */
export function tonStufe(volume) {
    return Math.round(volume * 20);
}
/**
 * Wo eine Ebene steht, als Zeichenkette.
 *
 * Vier Nachkommastellen: bei einer Leinwand von 1200 Punkten ist das ein
 * Achtel Punkt. Was sich langsamer bewegt, bewegt sich für das Auge nicht —
 * und was sich schneller bewegt, zeichnet weiter Bild für Bild, wie es soll.
 */
export function lageSchluessel(tf, anflug) {
    return [
        tf.x.toFixed(4),
        tf.y.toFixed(4),
        tf.scale.toFixed(4),
        tf.rotate.toFixed(3),
        tf.opacity.toFixed(3),
        anflug.dx.toFixed(4),
        anflug.dy.toFixed(4),
    ].join(' ');
}
//# sourceMappingURL=bildtakt.js.map